import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http"
import { Injectable, Injector } from "@angular/core"
import { Router } from "@angular/router"
import { environment } from "environments/environment"
import { FORBIDDEN, NOT_FOUND, UNAUTHORIZED } from "http-status-codes"
import { Observable } from "rxjs"
import { catchError, switchMap } from "rxjs/operators"
import { ApiService } from "./api.service"
import { AuthService } from "./auth.service"
import { Qualiti } from "./qualiti"
import { SwalService } from "./swal.service"

@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {
  public authService: AuthService
  public apiService: ApiService
  public router: Router
  public qualiti: Qualiti
  constructor(
    private injector: Injector,
  ) {
    this.qualiti = new Qualiti()
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.authService = this.injector.get<AuthService>(AuthService)
    this.apiService = this.injector.get<ApiService>(ApiService)
    this.router = this.injector.get<Router>(Router)

    req = req.clone({
      setHeaders: {
        Authorization: this.authService.getAuthHeader(),
      },
    })

    return next.handle(req).pipe(
      catchError(err => this.handleError(err, req, next)),
    )
  }

  private handleError(err: any, initialRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (err instanceof HttpErrorResponse) {
      if (err.status === UNAUTHORIZED) {
        console.error("RECEIVED 401 UNAUTHORIZED. Attempting to get token from refresh token")
        return this.handleUnauthorizedError(err, initialRequest, next)
      } else if (err.status === FORBIDDEN) {
        this.router.navigate(["forbidden"])
      } else if (err.status === NOT_FOUND && err.url.startsWith(environment.api.url.replace("https://", ""))) {
        // Ignore these errors, except if its from the API
        console.error(err.status)
      } else {
        console.error(err)
      }
    }
    throw err
  }

  private handleUnauthorizedError(err: any, initialRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService
      .authenticateWithRefreshToken(err)
      .pipe<any, HttpEvent<any>>(
        switchMap(() => {
          const requestWithUpdatedAuth = initialRequest.clone({
            setHeaders: {
              Authorization: this.authService.getAuthHeader(),
            },
          })

          // Since the authentication is refreshed, then handle the same request again.
          return next.handle(requestWithUpdatedAuth)
        }),
        catchError(async refreshTokenErr => {
          console.error(refreshTokenErr)
          await SwalService.showModal(`UNAUTHORIZED: ${err.message}`)
          await this.authService.logout()
          this.router.navigate(["login"])
        }),
      )
  }
}
